interface SliceResult<T> {
    prev: T[];
    current: T;
    next: T[];
}

type sameFunc<T> = ((f: T) => T);

export function arraySlice<T>(arr: T[], n: number): SliceResult<T> {

    return {
        prev: arr.slice(0, n),
        current: arr[n],
        next: arr.slice(n + 1)
    };
}

export function updateElement<T>(arr: T[], n: number, elem: T): T[];
export function updateElement<T>(arr: T[], n: number, elemFunc: ((t: T) => T)): T[];
export function updateElement<T>(arr: T[], n: number, elem: T | ((t: T) => T)): T[] {
    const slices = arraySlice(arr, n);
    const newElem = (typeof (elem) === "function")
        ? (elem as sameFunc<T>)(slices.current)
        : elem;
    return slices.prev
        .concat(newElem)
        .concat(...slices.next);
}


export function min<T>(ts: T[], func: (t: T) => number): T | undefined {
    if (ts.length === 0)
        return undefined;

    let minT = ts[0];
    let minVal = func(minT);
    for (let i = 1; i < ts.length; i++) {
        const t = ts[i];
        const tVal = func(t);
        if (tVal < minVal) {
            minVal = tVal;
            minT = t;
        }
    }
    return minT;
}
